const SKIP_WAITING = {type: "SKIP_WAITING"} as const;

/** Drop Workbox precache/runtime caches so the next navigation fetches fresh assets. */
export async function clearAppCaches(): Promise<void> {
  if (!("caches" in window)) {
    return;
  }

  const keys = await caches.keys();
  await Promise.all(keys.map((key) => caches.delete(key)));
}

function postSkipWaiting(registration: ServiceWorkerRegistration) {
  registration.waiting?.postMessage(SKIP_WAITING);
  const installing = registration.installing;
  if (!installing) {
    return;
  }

  installing.addEventListener("statechange", () => {
    if (installing.state === "installed" && registration.waiting) {
      registration.waiting.postMessage(SKIP_WAITING);
    }
  });
}

async function nudgeServiceWorkerUpdate() {
  if (!("serviceWorker" in navigator)) {
    return;
  }

  try {
    const registration = await navigator.serviceWorker.ready;
    postSkipWaiting(registration);
    await registration.update();
  } catch {
    // SW unavailable — cache purge + reload still applies.
  }
}

/**
 * Apply a deploy while the old service worker still controls the page.
 * A plain reload keeps serving precached index.html + old hashed chunks.
 */
export async function forceDeployReload(): Promise<void> {
  await Promise.all([clearAppCaches(), nudgeServiceWorkerUpdate()]);

  const url = new URL(window.location.href);
  url.searchParams.set("_deploy", Date.now().toString());
  window.location.replace(url.toString());
}

/** Remove cache-bust query param left by {@link forceDeployReload} after a successful load. */
export function stripDeployQueryParam(): void {
  const url = new URL(window.location.href);
  if (!url.searchParams.has("_deploy")) {
    return;
  }
  url.searchParams.delete("_deploy");
  window.history.replaceState(window.history.state, "", url.pathname + url.search + url.hash);
}
